module.exports = __webpack_public_path__ + "static/img/fefco426_1.d8982cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco426_1.png
// module id = 09vE
// module chunks = 0